module.exports = __webpack_public_path__ + "static/img/3.0a1c67d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/3.png
// module id = M3QZ
// module chunks = 0